<template>
    <li class="nav-item">
        <a :href="url('wishlist')" class="nav-link">
            {{t.wishlist.wishlist}} <i class="fa-solid fa-heart"></i> <span class="badge rounded-pill bg-primary">{{this.wishlist.length}}</span>
        </a>
    </li>
</template>
<script>
export default {
    data() {
        return {
            t: t,
            wishlist: wishlist
        }
    },
    mounted() {
        this.$root.$on('updateWishlist', wishlist => {
            this.wishlist = wishlist
        });
    },
}
</script>
